import type { MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import { ArrowUpIcon } from '@heroicons/react/24/outline';

export const meta: MetaFunction = ({ data, params }: { data: any, params: any }) => {
  const title = `Bookmarklet - Related Repos`;
  const description = 'Official bookmarklet for web browsers. Quickly view alternative repositories while browsing open source projects online. Find useful libraries.';
  const canonicalURL = `${__BASE_URL__}/bookmarklet`;
  const jsonLD = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": canonicalURL
  };

  return [
    { title },
    { name: "description", content: description },
    { tagName: "link", rel: "canonical", href: canonicalURL },
    { "script:ld+json": jsonLD },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonicalURL },
    { property: "og:image", content: __OG_IMAGE__ }
  ];
};

const unsafeHtml = `
<a href="javascript:(function()%7Bconst%20url%3Dwindow.location.href%2CGITHUB_REGEX%3Dnew%20RegExp(%22(%3F%3Ahttp%7Chttps)%3A%5C%5C%2F%5C%5C%2Fgithub.com%5C%5C%2F(%5BA-Za-z0-9-%5D%2B)%5C%5C%2F(%5BA-Za-z0-9-_%5C%5C.%5D%2B)%22)%2Cres%3DGITHUB_REGEX.exec(url)%3Bres%3Fwindow.open(%60https%3A%2F%2Frelatedrepos.com%2Fgh%2F%24%7Bres%5B1%5D%7D%2F%24%7Bres%5B2%5D%7D%60%2C%22_blank%22)%3Aalert(%22Please%20first%20visit%20a%20repo%20on%20GitHub.%5CnFor%20example%3A%20github.com%2Fairbnb%2Fjavascript%22)%3B%7D)()" type="button" class="text-rr-button-blue-primary background-button-blue inline-flex items-center gap-x-1.5 rounded-full px-4 py-2.5 text-sm font-semibold shadow-sm ring-1 ring-inset ring-gray-300">
  Related Repos
</a>
`

export default function Index() {
  return (
    <>
      <div className="background-gray px-2 py-2 border border-gray-100 rounded-md">
        <div className="flex items-center py-1">
          <h1 className="text-xl font-bold mr-1 ">
            Bookmarklet
          </h1>
        </div>
      </div>

      <div className="max-w-prose mx-auto pb-10 ">
        <p className="mt-4 mb-5 text-xl text-center">
          Quickly view alternative repositories while browsing on GitHub
        </p>

        {/* A future version of React will block javascript: URLs as a security precaution, so use dangerouslySetInnerHTML */}
        <div className="flex justify-center gap-x-5 gap-y-4 flex-wrap mb-6 mt-2" dangerouslySetInnerHTML={{ __html: unsafeHtml }}>
        </div>

        <div className="text-center text-lg mb-6 mt-2">
          {/* <ArrowUpIcon className="text-rr-primary size-5 mr-1 inline-block" /> */}
          Drag and drop the above bookmarklet link into your browser's bookmarks toolbar
        </div>

        <video className="mx-auto border border-gray-400 rounded" width="600" controls autoPlay loop muted>
          <source src="https://d2jboulw3rwjex.cloudfront.net/videos/bookmarklet_recording.mov" type="video/mp4" />
          {/* fallback to image if video not supported */}
          <img width="600" src="/images/bookmarklet_screenshot.png" alt="Bookmarklet screenshot" />
        </video>

        <ul className="text-lg list-disc pl-8 mt-4">
          <li className="py-1">
            Click the bookmarklet when viewing a public repository on GitHub
          </li>
          <li className="py-1">
            A new tab will open displaying related projects for the repo
          </li>
          <li className="py-1">
            Alternatively, use the <Link to="/extension" className="text-rr-link">official browser extension</Link> for a fully integrated experience
          </li>
          <li className="py-1">
            <a className="text-rr-link" href="https://gist.github.com/plurch/5097c1e0cd3936f2fa87cecbcfbfaea6" target="_blank">Source code</a>
          </li>
        </ul>

      </div>
    </>
  );
}
